<template>
    <transition enter-active-class="animated tada" leave-active-class="animated bounceOutLeft">
      <div class="d-flex  ">
        <div class="alert-center pos-center alert position-fixed z-index-10 mx-auto w-25 text-center xy-align"
             :class="'alert-'+ alertData.type"
             v-if="alertData.body">
          <ul class="mb-0 p-0">
            <li v-for="msg in alertBody" style="list-style: none">{{msg}}</li>
          </ul>
        </div>
      </div>

    </transition>

</template>


<script>
  export default {
    props: ['alertData'],
    computed: {
      alertBody () {
        const msgs = new Array()
        if (typeof this.alertData.body === 'object') {
          for (let i in this.alertData.body) {
            for (let msg in this.alertData.body[i]) {
              console.log(this.alertData.body[i][msg])
              msgs.push(this.alertData.body[i][msg])
            }
          }
          console.log(msgs)
        } else {

          msgs.push(this.alertData.body)
        }
        return msgs
      }
    }
  }
</script>
